import axios from 'axios'

export default {
    get: () => axios.get('sales'),
    getFiltered: (data) => axios.post('sales', data),
    store: (data) => axios.post('sales/store', data),
    update: (data) => axios.post('sales/update', data),
    delete: (id) => axios.post('sales/delete', id),
    import: (data) => axios.post('sales/import', data),
}